import React from 'react';
import MilitaryBanner from './MilitaryBanner';
import MexicanFlagBanner from './MexicanFlagBanner';

const Hero = () => {
  return (
    <section className="hero">
      <MilitaryBanner />
      <MexicanFlagBanner />
      <div className="hero-content">
        <div className="hero-image">
          <div className="hero-main-image placeholder-image">
          </div>
        </div>
        <div className="invitation-text">
          <h3>LA 25 ZONA MILITAR TE INVITA A LA:</h3>
        </div>
        <h1>RODADA CICLISTA</h1>
        <h2 className="challenge-text">POR LOS SENDEROS DEL MANDO</h2>
        <div className="challenge-questions">
          <p className="challenge-question">¿TE ATREVES A SUBIR EL TEPOZUCHITL?</p>
          <p className="challenge-call">RUEDA HACIA EL DESAFÍO</p>
        </div>
        
      </div>
    </section>
  );
};

export default Hero;
